import { withInstall } from '/@/utils';
import qrCode from './src/Qrcode.vue';

export const QrCode = withInstall(qrCode);
export * from './src/typing';
